import * as React from "react"

type PageHeaderProps = {
  title: React.ReactNode
  description?: React.ReactNode
  actions?: React.ReactNode
  tabs?: React.ReactNode
}

export function PageHeader({ title, description, actions, tabs }: PageHeaderProps) {
  return (
    <div>
      <div className={`flex flex-col gap-4 pb-6 sm:flex-row sm:items-start sm:justify-between ${tabs ? "" : "border-b border-hairline"}`}>
        <div>
          <h1>{title}</h1>
          {description && <p className="mt-1 text-sm/6 text-ink-muted">{description}</p>}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </div>
      {tabs}
    </div>
  )
}
